<page-with-permissions-wrapper>
  <released-sprints [board$]="board$" *ngIf="isOkStatus$ | async"></released-sprints>
</page-with-permissions-wrapper>
